import React, { Component } from "react";
import { config } from "./api/endPoints";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
//import EmployeeBulkUpload from "./components/domain/employee/EmployeeBulkImportExport/EmployeeBulkImportExport";
import { Login } from "./components/domain/accounts/login";
import { RegisterContainer } from "./components/domain/accounts/register";
import ForgotPasswordContainer from "./components/domain/accounts/forgotPassword/forgotPasswordContainer";
import Dashboard from "./components/domain/dashboard/dashboard";
// import Employee from "./components/domain/employee/employeeDashboard";
// import AddEmployee from "./components/domain/employee/addEmployee";
import Users from "./components/domain/users/users";
import UserForm from "./components/domain/users/userForm";
import UserProfilePage from "./components/domain/users/UserProfilePage";
import AddCompany from "./components/domain/company/addCompany/addCompany";
import CompanyDashboard from "./components/domain/company/companyDashboard/companyDashboard";
import OfficeDashboard from "./components/domain/company/companyOffices/officeDashboard/officeDashboard";
import OnboardingPage from "./components/domain/onboarding/OnboardingPage";
import { needsAdminOnboarding } from "./utils/onboardingUtils";
import { isSuperAdminInCompany, isSuperAdminRole } from "./utils/superAdminContext";
import AddOffice from "./components/domain/company/companyOffices/addOffice/addOffice";
import { RealTimeUpdates } from "./components/realtime";
// import EmployeeDepartment from "./components/domain/employee/employeeDepartment";
// import EmployeeSkill from "./components/domain/employee/skills/employeeSkill";
// import SalaryList from "./components/domain/salaryHistory/salaryList";
// import EmployeeSalaryHistory from "./components/domain/salaryHistory/employeeSalaryHistory";
// import AddDepartment from "./components/domain/department/addDepartment";
// import EditDepartment from "./components/domain/department/editDepartment";
// import AddEmployeeSkill from "./components/domain/employee/skills/addEmployeeSkill";
// import EditEmployeeSkill from "./components/domain/employee/skills/editEmployeeSkill";
import EmployeesCalender from "./components/domain/timeOff/employeesCelanderList";
import MainYearCelander from "./components/domain/timeOff/mainYearCelander";
import Analytics from './components/domain/company/companyOffices/officeDashboard/Analytics';

import { Header } from "./components/common/";
import NotFound from "./components/common/NotFound";
import EmployeeDetailView from "./components/domain/employee/Employee-Profile/employeeDetailView";
import {
  getSelectedOffice,
  getSelectedCompany,
  removeSpace,
  clearSelectedCompAndOffice,
  clearCurrentEmployee,
  getAuthenticationToken,
} from "./components/Global/CustomFunctions";
import { createBrowserHistory } from "history";
import * as AccountActions from "./components/domain/accounts/accountActions";
import * as officeActions from "./components/domain/company/companyOffices/officeActions";
import * as hubActions from "./components/realtime/hubActions";
import { WebStorage, WebStorageNames } from "./utils";
import CompanySettings from "./components/common/header/settings/CompanySettings";
import LeaveSettings from "./components/common/header/settings/LeaveSettings";
import Department from "./components/common/header/settings/departments";
import Designation from "./components/common/header/settings/designations";
import EmploymentType from "./components/common/header/settings/employmentTypes";
import Project from "./components/common/header/settings/projects";
import ProjectFormPage from "./components/common/header/settings/projects/ProjectFormPage";
import Team from "./components/common/header/settings/teams";
import HomeDashboard from "./components/domain/dashboard/HomeDashboard";
import Layout from "./components/common/layout/Layout";
import LeaveApprovalDashboard from "./components/domain/leaveApproval/LeaveApprovalDashboard";
import ApprovalHistory from "./components/domain/leaveApproval/ApprovalHistory";
import MyLeaveRequests from "./components/domain/leaveApproval/MyLeaveRequests";
import NotificationsScreen from "./components/domain/notifications/NotificationsScreen";
import HelpSupportPage from "./components/domain/helpSupport/HelpSupportPage";
import HelpSupportCreatePage from "./components/domain/helpSupport/HelpSupportCreatePage";
import HelpSupportDetailPage from "./components/domain/helpSupport/HelpSupportDetailPage";
import DocumentLibrary from "./components/domain/documents/DocumentLibrary";
import ComplianceTracking from "./components/domain/documents/ComplianceTracking";
import RequiredActions from "./components/domain/documents/RequiredActions";
import TimeSheetReportsPage from "./components/domain/timesheets/TimeSheetReportsPage";
import TimeLogPage from "./components/domain/timesheets/TimeLogPage";
import TimeSheetEntryPage from "./components/domain/timesheets/TimeSheetEntryPage";
import TimeSheetApprovalsPage from "./components/domain/timesheets/TimeSheetApprovalsPage";
import AttendanceHubPage from "./components/domain/attendance/AttendanceHubPage";
import AttendanceDailyLogsPage from "./components/domain/attendance/AttendanceDailyLogsPage";
import AttendanceReportsPage from "./components/domain/attendance/AttendanceReportsPage";
import AttendanceConfigurationPage from "./components/domain/attendance/AttendanceConfigurationPage";
import AttendanceMachinesPage from "./components/domain/attendance/AttendanceMachinesPage";
import AttendanceAgentBindPage from "./components/domain/attendance/AttendanceAgentBindPage";
import AppraisalSettingsPage from "./components/domain/appraisal/AppraisalSettingsPage";
import AppraisalOverviewPage from "./components/domain/appraisal/AppraisalOverviewPage";
import AppraisalFrameworkPage from "./components/domain/appraisal/AppraisalFrameworkPage";
import AppraisalTeamPage from "./components/domain/appraisal/AppraisalTeamPage";
import AppraisalAssessmentPage from "./components/domain/appraisal/AppraisalAssessmentPage";
import AppraisalObjectivesPage from "./components/domain/appraisal/AppraisalObjectivesPage";
import AppraisalGoalsPage from "./components/domain/appraisal/AppraisalGoalsPage";
import AppraisalRetrospectivePage from "./components/domain/appraisal/AppraisalRetrospectivePage";
import AppraisalEvidencePage from "./components/domain/appraisal/AppraisalEvidencePage";
import AppraisalPdpPage from "./components/domain/appraisal/AppraisalPdpPage";
import AppraisalOneToOnePage from "./components/domain/appraisal/AppraisalOneToOnePage";
import AppraisalConversationPage from "./components/domain/appraisal/AppraisalConversationPage";
import AppraisalLmsPage from "./components/domain/appraisal/AppraisalLmsPage";
import { canAccessMyAppraisal, getAppraisalHomePath } from "./components/domain/appraisal/appraisalAccess";
import AppraisalFeatureGate from "./components/domain/appraisal/AppraisalFeatureGate";
import AttendanceCorrectionsQueuePage from "./components/domain/attendance/AttendanceCorrectionsQueuePage";
import AttendanceSubmittedRequestsPage from "./components/domain/attendance/AttendanceSubmittedRequestsPage";
import { showAttendanceSubmittedRequestsPage } from "./components/domain/attendance/attendanceAccessUtils";
import PayrollAdminShell from "./components/domain/payroll/PayrollAdminShell";
import PayrollOverviewPage from "./components/domain/payroll/PayrollOverviewPage";
import SalaryComponentsPage from "./components/domain/payroll/SalaryComponentsPage";
import PayrollStructuresPage from "./components/domain/payroll/PayrollStructuresPage";
import IncomeTaxesPage from "./components/domain/payroll/IncomeTaxesPage";
import SalaryAssignmentsPage from "./components/domain/payroll/SalaryAssignmentsPage";
import RunPayrollPage from "./components/domain/payroll/RunPayrollPage";
import BonusesPage from "./components/domain/payroll/BonusesPage";
import BonusGeneratePage from "./components/domain/payroll/BonusGeneratePage";
import SalaryIncrementsPage from "./components/domain/payroll/SalaryIncrementsPage";
// import SalaryCertificateRequestsPage from "./components/domain/payroll/SalaryCertificateRequestsPage";
import PayslipPreviewPage from "./components/domain/payroll/PayslipPreviewPage";
import SubscriptionRestrictedFeature from "./components/common/SubscriptionRestrictedFeature";

const { REST_API } = config;

class Routes extends Component {
  constructor(props) {
    super(props);
    let isUserloggedIn = WebStorage.getLocalStore(WebStorageNames.UserLoggedIn);
    let roleId = WebStorage.getLocalStore(WebStorageNames.RoleId);

    this.state = {
      isLoggedIn: isUserloggedIn,
      roleId: roleId,
    };
    // Create once — recreating in render() made history.push appear to do nothing
    // because Router was listening to a different history instance.
    this.history = createBrowserHistory();
  }

  componentWillReceiveProps(nextProps) {
    let isUserloggedIn = WebStorage.getLocalStore(WebStorageNames.UserLoggedIn);
    let roleId = WebStorage.getLocalStore(WebStorageNames.RoleId);
    if (isUserloggedIn) {
      this.setState({
        isLoggedIn: true,
        roleId: roleId,
      });
    } else {
      this.setState({
        isLoggedIn: false,
        roleId: null,
      });
    }
  }

  getLocalUserInfo() {
    return WebStorage.getLocalStore(WebStorageNames.UserInfo);
  }
  authenticate(SuccessComponent, FailComponentName) {
    const { isLoggedIn } = this.state;
    const loggedUser = this.getLocalUserInfo();
    if (loggedUser || isLoggedIn) {
      return <SuccessComponent />;
    }
    return <Redirect to={FailComponentName} />;
  }

  notAuthenticate(SuccessComponentName, FailComponent) {
    const { isLoggedIn } = this.state;
    const loggedUser = this.getLocalUserInfo();
    return loggedUser || isLoggedIn ? (
      <Redirect to={SuccessComponentName} />
    ) : (
      <FailComponent />
    );
  }
  render() {
    let { roleId } = this.state;
    // Always sync role from storage to avoid stale state after auth transitions
    const latestRoleId = WebStorage.getLocalStore(WebStorageNames.RoleId);
    roleId = latestRoleId ? parseInt(latestRoleId, 10) : (roleId ? parseInt(roleId, 10) : null);
    // Storage is the source of truth — sticky Redux/state must not keep the user
    // "logged in" after logout clears AuthInfo (that race sent SA to /dashboard).
    const authInfo = WebStorage.getLocalStore(WebStorageNames.AuthInfo);
    const storedLoggedIn = !!WebStorage.getLocalStore(WebStorageNames.UserLoggedIn);
    const hasValidSession = storedLoggedIn && !!(authInfo && authInfo.accessToken);
    const isLoggedIn = hasValidSession;
    const { isLoading, isOfficeSelected, accountActions, isAnnualLeavePopupShown } = this.props;
    const adminNeedsOnboarding =
      roleId === 2 && needsAdminOnboarding(isAnnualLeavePopupShown);
    // will use later
    let link = "";

    if (isOfficeSelected) {
      let company = getSelectedCompany();
      let office = getSelectedOffice();

      let resComp = removeSpace(company.Name);
      let resOffice = removeSpace(office.Name);
      link = `/${resComp + "/" + resOffice}/dashboard`;
    }
    let salaryListLink = link + "/salaryList";
    const history = this.history;
    const { pathname } = history.location;

    return (
      <Router history={history}>
        <div className="fluid-container">
          <Layout
            isLoading={isLoading}
            isLoggedIn={isLoggedIn}
            accountActions={accountActions}
            history={history}
          >
            <div
              className={`${isLoggedIn && isOfficeSelected
                ? "container clear"
                : pathname === "/login" || pathname === "/register" || pathname === "/auth" || pathname === "/onboarding"
                  ? ""
                  : "min-100vh"
                }`}
            >
              {isLoggedIn && isOfficeSelected}
              <div
                className={
                  isLoggedIn && isOfficeSelected
                    ? "body-content"
                    : pathname === "/login" || pathname === "/register" || pathname === "/auth" || pathname === "/onboarding"
                      ? ""
                      : "min-100vh"
                }
              >
                <Switch>
                  <Route
                    exact
                    path="/auth"
                    render={(props) =>
                      isLoggedIn ? (
                        <Redirect to={isSuperAdminRole(roleId) ? "/workplaces" : "/dashboard"} />
                      ) : (
                        <Login {...props} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/companies"
                    render={(props) =>
                      !isLoggedIn ? <Login {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/onboarding"
                    render={(props) => {
                      if (!isLoggedIn) return <Login {...props} />;
                      if (roleId !== 2) return <Redirect to="/workplaces" />;
                      if (!adminNeedsOnboarding) return <Redirect to="/workplaces" />;
                      return <OnboardingPage {...props} />;
                    }}
                  />
                  <Route
                    exact
                    path="/workplaces"
                    render={(props) => {
                      if (!isLoggedIn) return <Login {...props} />;
                      // Super Admin platform dashboard — roleId 1 only
                      if (isSuperAdminRole(roleId)) {
                        return <CompanyDashboard {...props} UserRoleId={roleId} />;
                      }
                      if (adminNeedsOnboarding) {
                        return <Redirect to="/onboarding" />;
                      }
                      return <OfficeDashboard {...props} UserRoleId={roleId} />;
                    }}
                  />
                  <Route
                    exact
                    path="/register"
                    render={(props) =>
                      !isLoggedIn ? (
                        <RegisterContainer {...props} />
                      ) : isSuperAdminRole(roleId) ? (
                        <Redirect to="/workplaces" />
                      ) : (
                        <Redirect to="/dashboard" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/dashboard/user-form"
                    render={(props) =>
                      isLoggedIn ? (
                        <UserForm {...props} />
                      ) : (
                        <Login {...props} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/dashboard"
                    render={(props) => {
                      if (!isLoggedIn) return <Login {...props} />;
                      // Super Admin platform home is /workplaces; company dashboard only after Enter
                      if (isSuperAdminRole(roleId) && !isSuperAdminInCompany()) {
                        return <Redirect to="/workplaces" />;
                      }
                      return <HomeDashboard {...props} />;
                    }}
                  />
                  <Route
                    exact
                    path="/login"
                    render={(props) =>
                      isLoggedIn ? (
                        <Redirect to={isSuperAdminRole(roleId) ? "/workplaces" : "/dashboard"} />
                      ) : (
                        <Login {...props} />
                      )
                    }
                  />

                  <Route
                    exact
                    path="/forgot-password"
                    render={(props) => !isLoggedIn && <ForgotPasswordContainer {...props} />}
                  />

                  <Route
                    exact
                    path="/"
                    render={(props) =>
                      isLoggedIn ? (
                        <Redirect to={isSuperAdminRole(roleId) ? "/workplaces" : "/dashboard"} />
                      ) : (
                        <Redirect to="/auth" />
                      )
                    }
                  />

                  <Route
                    exact
                    path="/create-company"
                    render={(props) => {
                      if (!isLoggedIn) return <Login {...props} />;
                      // Super Admin only — block every other role
                      if (!isSuperAdminRole(roleId)) {
                        return <Redirect to="/dashboard" />;
                      }
                      return <AddCompany {...props} />;
                    }}
                  />
                  <Route
                    exact
                    path="/settings/company"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : <CompanySettings {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/settings/leave"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : <LeaveSettings {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/settings/notifications"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/company?tab=notifications" />
                    }
                  />
                  <Route
                    exact
                    path="/leave/dashboard"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Analytics {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/departments"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : (roleId === 1 || roleId === 2) ? <Department {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/designations"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : (roleId === 1 || roleId === 2) ? <Designation {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/employee-types"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : (roleId === 1 || roleId === 2) ? <EmploymentType {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/projects/new"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : (roleId === 1 || roleId === 2) ? <ProjectFormPage {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/projects/edit"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : (roleId === 1 || roleId === 2) ? <ProjectFormPage {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/projects/:id/edit"
                    render={({ match }) =>
                      !isLoggedIn ? (
                        <Redirect to="/login" />
                      ) : (roleId === 1 || roleId === 2) ? (
                        <Redirect
                          to={{
                            pathname: "/settings/organization/projects/edit",
                            state: { projectId: match.params.id },
                          }}
                        />
                      ) : (
                        <Redirect to="/workplaces" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/projects"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : (roleId === 1 || roleId === 2) ? <Project {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/organization/teams"
                    render={(props) =>
                      !isLoggedIn ? <Redirect to="/login" /> : (roleId === 1 || roleId === 2) ? <Team {...props} /> : <Redirect to="/workplaces" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/departments"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/organization/departments" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/general"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/company" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/carry-forward"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/leave?tab=carryforward" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/leave-types"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/leave?tab=leavetypes" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/public-holidays"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/leave?tab=publicHolidays" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/backup"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/leave?tab=backup" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/billing"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/company?tab=billing" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/security"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/leave?tab=privacy" />
                    }
                  />
                  <Route
                    exact
                    path="/settings/danger-zone"
                    render={() =>
                      !isLoggedIn ? <Redirect to="/login" /> : <Redirect to="/settings/company?tab=dangerzone" />
                    }
                  />
                  <Route
                    exact
                    path="/:companyName/offices"
                    render={(props) => {
                      if (!isLoggedIn) return <Login {...props} />;
                      if (adminNeedsOnboarding) {
                        return <Redirect to="/onboarding" />;
                      }
                      return <OfficeDashboard {...props} roleId={roleId} />;
                    }}
                  />
                  <Route
                    exact
                    path="/:companyName/offices/create-office"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <AddOffice {...props} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/:companyName/offices/analytics"
                    render={() =>
                      isLoggedIn ? <Redirect to="/leave/dashboard" /> : <Redirect to="/login" />
                    }
                  />
                  <Route
                    exact
                    path="/:companyName/:officeName/dashboard"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <Dashboard {...props} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/profile"
                    render={(props) =>
                      isLoggedIn ? <UserProfilePage {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/users/view"
                    render={(props) =>
                      isLoggedIn ? <UserProfilePage {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/users"
                    render={(props) =>
                      isLoggedIn ? <Users {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/approvals"
                    render={(props) =>
                      isLoggedIn ? <LeaveApprovalDashboard {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/approvals/history"
                    render={(props) =>
                      isLoggedIn ? <ApprovalHistory {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/self-requests"
                    render={(props) =>
                      isLoggedIn ? <MyLeaveRequests {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/notifications"
                    render={(props) =>
                      isLoggedIn ? <NotificationsScreen {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/help-support"
                    render={(props) =>
                      isLoggedIn ? <HelpSupportPage {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/help-support/new"
                    render={(props) =>
                      isLoggedIn ? <HelpSupportCreatePage {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/help-support/:id"
                    render={(props) =>
                      isLoggedIn ? <HelpSupportDetailPage {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    exact
                    path="/documents/library"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessDocuments">
                          <DocumentLibrary {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : roleId === 3 || roleId === 4 ? (
                        <Redirect to="/documents/document-portal" />
                      ) : (
                        <Redirect to="/dashboard" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/documents/compliance"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessDocuments">
                          <ComplianceTracking {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : roleId === 3 || roleId === 4 ? (
                        <Redirect to="/documents/document-portal" />
                      ) : (
                        <Redirect to="/dashboard" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/documents/document-portal"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 3 || roleId === 4 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessDocuments">
                          <RequiredActions {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : roleId === 1 || roleId === 2 ? (
                        <Redirect to="/documents/library" />
                      ) : (
                        <Redirect to="/dashboard" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/documents/required-actions"
                    render={() => <Redirect to="/documents/document-portal" />}
                  />
                  <Route exact path="/timesheets" render={() => <Redirect to="/timesheets/time-log" />} />
                  <Route
                    exact
                    path="/timesheets/reports"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessTimeSheets">
                          <TimeSheetReportsPage {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : (
                        <Redirect to="/timesheets/time-log" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/timesheets/time-log/new"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessTimeSheets">
                          <TimeSheetEntryPage key="timelog-new" {...props} />
                        </SubscriptionRestrictedFeature>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/timesheets/time-log/edit"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessTimeSheets">
                          <TimeSheetEntryPage key={props.location.key} {...props} />
                        </SubscriptionRestrictedFeature>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/timesheets/time-log/edit/:entryId"
                    render={({ match, location }) => (
                      <Redirect
                        to={{
                          pathname: "/timesheets/time-log/edit",
                          state: { ...(location.state || {}), timeSheetId: match.params.entryId },
                        }}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/timesheets/time-log"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessTimeSheets">
                          <TimeLogPage {...props} />
                        </SubscriptionRestrictedFeature>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/timesheets/approvals"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessTimeSheets">
                          <TimeSheetApprovalsPage {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : (
                        <Redirect to="/timesheets/time-log" />
                      )
                    }
                  />
                  <Route exact path="/attendance" render={() => <Redirect to="/attendance/hub" />} />
                  <Route
                    exact
                    path="/attendance/hub"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                          <AttendanceHubPage {...props} />
                        </SubscriptionRestrictedFeature>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/attendance/daily-logs"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                          <AttendanceDailyLogsPage {...props} />
                        </SubscriptionRestrictedFeature>
                      )
                    }
                  />
                  <Route exact path="/attendance/change-requests" render={() => <Redirect to="/attendance/corrections" />} />
                  <Route
                    exact
                    path="/attendance/corrections"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                          <AttendanceCorrectionsQueuePage {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : roleId === 4 ? (
                        <Redirect to="/attendance/submitted-requests" />
                      ) : (
                        <Redirect to="/attendance/hub" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/attendance/submitted-requests"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : showAttendanceSubmittedRequestsPage(roleId) ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                          <AttendanceSubmittedRequestsPage {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : (
                        <Redirect to="/attendance/hub" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/attendance/reports"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                          <AttendanceReportsPage {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : (
                        <Redirect to="/attendance/hub" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/attendance/settings"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                          <AttendanceConfigurationPage {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : (
                        <Redirect to="/attendance/hub" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/attendance/machines"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                          <AttendanceMachinesPage {...props} />
                        </SubscriptionRestrictedFeature>
                      ) : (
                        <Redirect to="/attendance/hub" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/attendance-agent/bind"
                    render={(props) => {
                      if (!isLoggedIn) {
                        try {
                          const returnPath = `${props.location.pathname}${props.location.search || ""}`;
                          sessionStorage.setItem("hrmAttendanceAgentBindReturn", returnPath);
                        } catch {
                          /* ignore */
                        }
                        return <Login {...props} />;
                      }
                      if (roleId === 1 || roleId === 2) {
                        return (
                          <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessAttendance">
                            <AttendanceAgentBindPage {...props} />
                          </SubscriptionRestrictedFeature>
                        );
                      }
                      return <Redirect to="/attendance/hub" />;
                    }}
                  />
                  <Route exact path="/appraisal" render={() => {
                    if (!isLoggedIn) return <Redirect to="/login" />;
                    return <Redirect to={getAppraisalHomePath(roleId)} />;
                  }} />
                  <Route
                    exact
                    path="/appraisal/overview"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalOverviewPage {...props} />
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/settings"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <AppraisalSettingsPage {...props} />
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/framework"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <AppraisalFrameworkPage {...props} />
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/objectives"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <AppraisalFeatureGate flag="isKpi">
                          <AppraisalObjectivesPage {...props} />
                        </AppraisalFeatureGate>
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/team"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalTeamPage {...props} />
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/team-goals"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalFeatureGate flag="isKpi">
                          <AppraisalGoalsPage {...props} mode="team" />
                        </AppraisalFeatureGate>
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/self"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : canAccessMyAppraisal(roleId) ? (
                        <AppraisalAssessmentPage {...props} mode="self" />
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/goals"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : !canAccessMyAppraisal(roleId) ? (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      ) : (
                        <AppraisalFeatureGate flag="isKpi">
                          <AppraisalGoalsPage {...props} mode="mine" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/goals/:id"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <AppraisalFeatureGate flag="isKpi">
                          <AppraisalGoalsPage {...props} mode="detail" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/retrospectives"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <AppraisalFeatureGate flag="isRetrospective">
                          <AppraisalRetrospectivePage {...props} />
                        </AppraisalFeatureGate>
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/lms"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 ? (
                        <AppraisalFeatureGate flag="isLms">
                          <AppraisalLmsPage {...props} />
                        </AppraisalFeatureGate>
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/evidence"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : !canAccessMyAppraisal(roleId) ? (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      ) : (
                        <AppraisalEvidencePage {...props} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/pdp"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : !canAccessMyAppraisal(roleId) ? (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      ) : (
                        <AppraisalFeatureGate flag="isDevelopment">
                          <AppraisalPdpPage {...props} mode="mine" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/team-pdp"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalFeatureGate flag="isDevelopment">
                          <AppraisalPdpPage {...props} mode="team" />
                        </AppraisalFeatureGate>
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/pdp/:id"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <AppraisalFeatureGate flag="isDevelopment">
                          <AppraisalPdpPage {...props} mode="detail" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/one-to-one"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : !canAccessMyAppraisal(roleId) ? (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      ) : (
                        <AppraisalFeatureGate flag="isOneToOne">
                          <AppraisalOneToOnePage {...props} mode="mine" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/team-one-to-one"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalFeatureGate flag="isOneToOne">
                          <AppraisalOneToOnePage {...props} mode="team" />
                        </AppraisalFeatureGate>
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/one-to-one/:id"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <AppraisalFeatureGate flag="isOneToOne">
                          <AppraisalOneToOnePage {...props} mode="detail" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/conversations"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : !canAccessMyAppraisal(roleId) ? (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      ) : (
                        <AppraisalFeatureGate flag="isOneToOneConversation">
                          <AppraisalConversationPage {...props} mode="mine" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/team-conversations"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalFeatureGate flag="isOneToOneConversation">
                          <AppraisalConversationPage {...props} mode="team" />
                        </AppraisalFeatureGate>
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/conversations/:id"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <AppraisalFeatureGate flag="isOneToOneConversation">
                          <AppraisalConversationPage {...props} mode="detail" />
                        </AppraisalFeatureGate>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/assessment"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalAssessmentPage {...props} mode="team" />
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/appraisal/assessment/:id"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : roleId === 1 || roleId === 2 || roleId === 3 ? (
                        <AppraisalAssessmentPage {...props} mode="team" />
                      ) : (
                        <Redirect to={getAppraisalHomePath(roleId)} />
                      )
                    }
                  />
                  <Route exact path="/payroll" render={() => <Redirect to="/payroll/overview" />} />
                  <Route
                    exact
                    path="/payroll/overview"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <PayrollOverviewPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/salary-components"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <SalaryComponentsPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/payroll-structures"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <PayrollStructuresPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/income-taxes"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <IncomeTaxesPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/salary-assignments"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <SalaryAssignmentsPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/run-payroll"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <RunPayrollPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/bonuses"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <BonusesPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/bonuses/generate/:bonusPolicyId"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <BonusGeneratePage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/salary-increments"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <SalaryIncrementsPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/payroll/salary-certificate-requests"
                    render={() => <Redirect to="/payroll/overview" />}
                  />
                  <Route
                    exact
                    path="/payroll/payslip-preview"
                    render={(props) =>
                      !isLoggedIn ? (
                        <Login {...props} />
                      ) : (
                        <PayrollAdminShell>
                          <PayslipPreviewPage {...props} />
                        </PayrollAdminShell>
                      )
                    }
                  />
                  <Route
                    exact
                    path="/wallchart"
                    render={(props) => {
                      if (!isLoggedIn) {
                        return <Login {...props} />;
                      }
                      // Get selected company and office from localStorage
                      const selectedCompany = getSelectedCompany();
                      const selectedOffice = getSelectedOffice();

                      if (selectedCompany && selectedOffice) {
                        // Redirect to office-specific wallchart
                        const companyName = removeSpace(selectedCompany.name);
                        const officeName = removeSpace(selectedOffice.name);
                        return <Redirect to={`/${companyName}/${officeName}/dashboard/time-off`} />;
                      } else {
                        return <Redirect to="/workplaces" />;
                      }
                    }}
                  />
                  {/* 

                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/employees"
                  render={(props) =>
                    isLoggedIn ? <Employee {...props} /> : <Login {...props} />
                  }
                />
              <Route
                  exact
                  path="/:companyName/:officeName/dashboard/employees/bulkuploadEmployee"
                  render={(props) =>
                    isLoggedIn ? (
                      <EmployeeBulkUpload {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />

 <Route
                  exact
                  path="/:companyName/:officeName/dashboard/employee/add"
                  render={(props) =>
                    isLoggedIn ? (
                      <AddEmployee {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />

                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/employee/edit/:id"
                  render={(props) =>
                    isLoggedIn ? (
                      <AddEmployee {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/employee/detail/:id"
                  render={(props) =>
                    isLoggedIn ? (
                      <EmployeeDetailView {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />

<Route
                  exact
                  path="/:companyName/:officeName/dashboard/employee/edit/:id"
                  render={(props) =>
                    isLoggedIn ? (
                      <AddEmployee {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/employee/detail/:id"
                  render={(props) =>
                    isLoggedIn ? (
                      <EmployeeDetailView {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/department"
                  render={(props) =>
                    isLoggedIn ? (
                      <EmployeeDepartment {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/department/add"
                  render={(props) =>
                    isLoggedIn ? (
                      <AddDepartment {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/department/edit"
                  render={(props) =>
                    isLoggedIn ? (
                      <EditDepartment {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/skill"
                  render={(props) =>
                    isLoggedIn ? (
                      <EmployeeSkill {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/skill/add"
                  render={(props) =>
                    isLoggedIn ? (
                      <AddEmployeeSkill {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/skill/edit"
                  render={(props) =>
                    isLoggedIn ? (
                      <EditEmployeeSkill {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  exact
                  path="/:companyName/:officeName/dashboard/salarylist/history/:id"
                  render={(props) =>
                    isLoggedIn ? (
                      <EmployeeSalaryHistory {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />
                <Route
                  path="/:companyName/:officeName/dashboard/salarylist"
                  render={(props) =>
                    isLoggedIn ? (
                      <SalaryList {...props} />
                    ) : (
                      <Login {...props} />
                    )
                  }
                />

              */}
                  <Route
                    path="/:companyName/:officeName/dashboard/time-off"
                    render={(props) =>
                      isLoggedIn ? (
                        <EmployeesCalender {...props} />
                      ) : (
                        <Login {...props} />
                      )
                    }
                  />
                  <Route
                    path="/:companyName/:officeName/dashboard/calender"
                    render={(props) =>
                      isLoggedIn ? (
                        <MainYearCelander {...props} />
                      ) : (
                        <Login {...props} />
                      )
                    }
                  />

                  <Route component={NotFound} />
                </Switch>
                {this.props.isLoggedIn && (
                  <RealTimeUpdates
                    isLoggedIn={this.props.isLoggedIn}
                    hubConnection={this.props.hubConnection}
                    hubActions={this.props.hubActions}
                    history={history}
                  />
                )}
              </div>
            </div>
          </Layout>
        </div>
      </Router>
    );
  }
}
const mapStateToProps = ({ accountReducer, officeReducer, hubReducer }) => {
  const { isLoggedIn, hubConnection, isAnnualLeavePopupShown } = accountReducer;
  const { isOfficeSelected } = officeReducer;
  return { isOfficeSelected, isLoggedIn, hubConnection, isAnnualLeavePopupShown };
};
const mapDispatchToProps = (dispatch) => {
  return {
    accountActions: bindActionCreators(AccountActions, dispatch),
    officeActions: bindActionCreators(officeActions, dispatch),
    hubActions: bindActionCreators(hubActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Routes);
